/**
 * Table Component
 * 
 * Responsive table rendering using Mantine components
 * Following Mantine design system patterns for tables
 */

import React from 'react';
import { Table as MantineTable, ScrollArea, Box } from '@mantine/core';
import classes from './Table.module.css';
import type { TableProps } from '../types';

export const Table: React.FC<TableProps> = ({ children }) => {
  return (
    <Box className={classes.tableContainer}>
      <ScrollArea>
        <MantineTable
          striped
          highlightOnHover
          withTableBorder
          withColumnBorders
          className={classes.table}
        >
          {children}
        </MantineTable>
      </ScrollArea>
    </Box>
  );
};